import React from 'react';
import styled from 'styled-components';

import { ISubmissionSearchResult } from 'typings/submission';
import RecentlyReadCard from 'components/Cards/RecentlyReadCard';

export const SubmissionCardLink = styled.a`
  cursor: pointer;
  text-decoration: none;
  outline: none;
  color: inherit;
`;

interface Props {
  submission: ISubmissionSearchResult;
  logEvent?: () => void;
}

const RecentlyReadSubmission = (props: Props) => {
  const { submission } = props;
  return (
    <SubmissionCardLink
      id={`sub${submission.id}`}
      className="test-Recent-ResearchLink"
      key={submission.id}
      href={`/o/article/${submission.id}`}
      rel="noopener noreferrer"
      target="_blank"
      onClick={() => props.logEvent && props.logEvent()}
    >
      <RecentlyReadCard
        key={`${submission.id}-submission-card`}
        eventName={submission.eventName || ''}
        title={submission.title || ''}
        authors={submission.authors || []}
      />
    </SubmissionCardLink>
  );
};

export default RecentlyReadSubmission;
